import { ProviderPopupClosedError } from '../../errors/provider-popup-closed-error';

export class LinkedInPopupClosedError extends ProviderPopupClosedError {
	constructor() {
		super();
		this.name = 'LinkedInPopupClosedError';
	}
}
